// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 系统首页
import Dashboard from '@/views/dashboard/Dashboard';
// 商品管理
import Goods from '@/views/goods/Goods';
// 商品基础信息管理
import GoodInfo from '@/views/goods/GoodInfo';
// 订单详情
import GoodInfoDetail from '@/views/goods/GoodInfoDetail';
// 商品标签管理
import GoodLabel from '@/views/goods/GoodLabel';
// 商品关联管理
import GoodAssociation from '@/views/goods/GoodAssociation';
// 动态属性管理
import GoodAttr from '@/views/goods/GoodAttr';
// 页面推荐管理
import Goodmend from '@/views/goods/Goodmend';

/*
 * 入驻商规则
 */
// 入驻商规则
import RulesInbound from '@/views/rules/rulesInbound';
// 规范详情
import RulesDetails from '@/views/rules/rulesDetails';

/**
 * 店铺管理
 */
// 店铺信息管理
import storeMessage from '@/views/store/storeMessage';
// 店铺分类管理
import storeSort from '@/views/store/storeSort';
// 店铺装饰管理
import storeDecoration from '@/views/store/storeDecoration';
// 快递邮费管理
import expressFee from '@/views/store/expressFee';
// 快递设置管理
import storeExpress from '@/views/store/storeExpress';
// 绑定打印机
import storePrinter from '@/views/store/storePrinter';

/**
 * 订单管理
 */
// 全部订单
import AllOrder from '@/views/order/AllOrder';
// 订单详情
import orderDetail from '@/views/order/orderDetail';
// 发货单
import invoiceOrder from '@/views/order/invoiceOrder';
// 修改订单商品
import modifyOrder from '@/views/order/modifyOrder';
// 代发详情
import proxyDetails from '@/views/order/proxyDetails';

/**
 * 供货管理
 */
// 供货关系类型管理
import supplyType from '@/views/supply/supplyType';
// 供货关系管理
import supplyRelationship from '@/views/supply/supplyRelationship';
// 供货商品管理
import supplyGood from '@/views/supply/supplyGood';
// 供货订单管理
import supplyOrder from '@/views/supply/supplyOrder';

// 供货对账单
import supplyReconciliation from '@/views/supply/supplyReconciliation';
// 供货提现
import supplyWithdrawal from '@/views/supply/supplyWithdrawal';
// 供货发票管理
import supplyInvoice from '@/views/supply/supplyInvoice';
// 需供货商品管理
import quiltSupplyGood from '@/views/supply/quiltSupplyGood';
// 开票记录
import supplyRecords from '@/views/supply/supplyRecords';
// 开票记录
import supplyReturn from '@/views/supply/supplyReturn';
// 退货服务单详情
import supplySaleDetail from '@/views/supply/supplySaleDetail';
// 供货退货单
import supplyInvoiceOrder from '@/views/supply/supplyInvoiceOrder';

/**
 * 售后服务
 */
// 售后单管理
import Aftersale from '@/views/aftersale/Aftersale';
// 售后地址管理
import AftersaleAddress from '@/views/aftersale/AftersaleAddress';
// 售后服务
import AftersaleService from '@/views/aftersale/AftersaleService';
// 服务单详情
import aftersaleDetail from '@/views/aftersale/aftersaleDetail';
// 新增售后单
import addAftersale from '@/views/aftersale/addAftersale';

/**
 * 营销管理
 */
// 优惠券规则
import couponRules from '@/views/Marketing/couponRules';
// 优惠券管理
import couponManage from '@/views/Marketing/couponManage';
// 商品赠品管理
import Gift from '@/views/Marketing/Gift';
// 秒杀管理
import flashManage from '@/views/Marketing/flashManage';
// 拼团管理
import groupManage from '@/views/Marketing/groupManage';
// 订单满减管理
import orderFullRedManage from '@/views/Marketing/orderFullRedManage';
// 订单满赠管理
import orderFullGiftManage from '@/views/Marketing/orderFullGiftManage';
// 商品议价管理
import goodBargaining from '@/views/Marketing/goodBargaining';
// 专属商城管理
import ExclusiveGaining from '@/views/store/ExclusiveGaining';
// 设置商城分类
import ificationGaining from '@/views/store/ificationGaining';
// 设置商城商品
import productsGaining from '@/views/store/productsGaining';
// 设置单位
import unitGaining from '@/views/store/unitGaining';
// 客户账期管理
import storeAccount from '@/views/store/storeAccount';

/**
 * 财务管理
 */
// 已开发票
import Invoice from '@/views/finance/Invoice';
// 开票申请
import InvoicingApplication from '@/views/finance/InvoicingApplication';
// 对账信息
import Reconciliation from '@/views/finance/Reconciliation';
// 服务费开票
import serviceInvoicie from '@/views/finance/serviceInvoicie';
// 月账单详情
import invoiceDetail from '@/views/finance/invoiceDetail';
// 订单提现
import orderWithdrawal from '@/views/finance/orderWithdrawal';
// 入驻协议
import Agreement from '@/views/finance/Agreement';

/**
 * 会员服务管理
 */
// 商品-咨询管理
import Productconsultation from '@/views/service/Productconsultation';
// 商品-评价管理
import Reviews from '@/views/service/Reviews';

/**
 * 系统信息
 */
import systemMessages from '@/views/system/systemMessages';

/**
 * 版本更新日志
 */
import versionAuto from '@/views/version/versionAuto';

/**
 * 客服系统
 */
import customer from '@/views/customer/customer';

// 启用路由
Vue.use(Router);

// 导出路由

const routes = [{
  path: '/',
  name: '',
  component: login,
  hidden: true,
  meta: {
    requireAuth: false
  }
}, {
  path: '/login',
  name: '登录',
  component: login,
  hidden: true,
  meta: {
    requireAuth: false
  }
}, {
  path: '/index',
  name: '首页',
  component: index,
  iconCls: 'el-icon-tickets',
  children: [{
    path: '/dashboard/Dashboard',
    name: '首页',
    component: Dashboard,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/goods/Goods',
    name: '商品上架管理',
    component: Goods,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/goods/GoodLabel',
    name: '商品标签管理',
    component: GoodLabel,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/goods/GoodAttr',
    name: '动态属性管理',
    component: GoodAttr,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/goods/GoodAssociation',
    name: '商品关联管理',
    component: GoodAssociation,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/goods/Goodmend',
    name: '页面推荐管理',
    component: Goodmend,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/goods/GoodInfo',
    name: '商品基础信息管理',
    component: GoodInfo,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/goods/GoodInfoDetail',
    name: '商品基础信息详情',
    component: GoodInfoDetail,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },{
    path: '/rules/RulesInbound',
    name: '入驻商规则',
    component: RulesInbound,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },{
    path: '/rules/RulesDetails',
    name: '规范详情',
    component: RulesDetails,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },{
    path: '/store/storeMessage',
    name: '店铺信息管理',
    component: storeMessage,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/store/storeSort',
    name: '店铺分类管理',
    component: storeSort,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/store/storeDecoration',
    name: '店铺装饰管理',
    component: storeDecoration,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/store/expressFee',
    name: '快递运费管理',
    component: expressFee,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/store/storeExpress',
    name: '快递设置管理',
    component: storeExpress,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/store/storePrinter',
    name: '绑定打印机',
    component: storePrinter,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/order/AllOrder',
    name: '订单管理',
    component: AllOrder,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/order/orderDetail',
    name: '订单详情',
    component: orderDetail,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/order/proxyDetails',
    name: '代发详情',
    component: proxyDetails,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/supply/supplyType',
    name: '供货身份管理',
    component: supplyType,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/supply/supplyRelationship',
    name: '供货关系管理',
    component: supplyRelationship,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/supply/supplyGood',
    name: '供货商品管理',
    component: supplyGood,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/supply/supplyOrder',
    name: '供货订单管理',
    component: supplyOrder,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/supply/supplyReconciliation',
    name: '供货对账单',
    component: supplyReconciliation,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/supply/supplyWithdrawal',
    name: '供货提现',
    component: supplyWithdrawal,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/supply/supplyInvoice',
    name: '供货发票管理',
    component: supplyInvoice,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/supply/quiltSupplyGood',
    name: '需供货商品管理',
    component: quiltSupplyGood,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/supply/supplyRecords',
    name: '开票记录',
    component: supplyRecords,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },{
    path: '/supply/supplyReturn',
    name: '供货退货管理',
    component: supplyReturn,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/supply/supplySaleDetail',
    name: '退货服务单详情',
    component: supplySaleDetail,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/order/invoiceOrder',
    name: '发货单',
    component: invoiceOrder,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/supply/supplyInvoiceOrder',
    name: '供货发货单',
    component: supplyInvoiceOrder,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/order/modifyOrder',
    name: '修改订单商品',
    component: modifyOrder,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/finance/Invoice',
    name: '已开发票',
    component: Invoice,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/finance/InvoicingApplication',
    name: '开票申请',
    component: InvoicingApplication,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/finance/Reconciliation',
    name: '对账单',
    component: Reconciliation,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/finance/serviceInvoicie',
    name: '服务费开票',
    component: serviceInvoicie,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/finance/orderWithdrawal',
    name: '订单提现',
    component: orderWithdrawal,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/finance/Agreement',
    name: '入驻协议',
    component: Agreement,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/aftersale/Aftersale',
    name: '售后单管理',
    component: Aftersale,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/aftersale/addAftersale',
    name: '新增售后单',
    component: addAftersale,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/aftersale/AftersaleAddress',
    name: '售后地址管理',
    component: AftersaleAddress,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },{
    path: '/aftersale/AftersaleService',
    name: '售后服务管理',
    component: AftersaleService,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/aftersale/aftersaleDetail',
    name: '服务单详情',
    component: aftersaleDetail,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/Marketing/couponRules',
    name: '优惠券规则管理',
    component: couponRules,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Marketing/couponManage',
    name: '优惠券管理',
    component: couponManage,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Marketing/Gift',
    name: '商品赠品管理',
    component: Gift,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Marketing/flashManage',
    name: '秒杀管理',
    component: flashManage,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Marketing/groupManage',
    name: '拼团管理',
    component: groupManage,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Marketing/orderFullRedManage',
    name: '订单满减管理',
    component: orderFullRedManage,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Marketing/orderFullGiftManage',
    name: '订单满赠管理',
    component: orderFullGiftManage,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/Marketing/goodBargaining',
    name: '商品议价管理',
    component: goodBargaining,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/store/ExclusiveGaining',
    name: '专属商城管理',
    component: ExclusiveGaining,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/store/storeAccount',
    name: '客户账期管理',
    component: storeAccount,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  }, {
    path: '/store/ificationGaining',
    name: '设置商城分类',
    component: ificationGaining,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/store/productsGaining',
    name: '设置商城商品',
    component: productsGaining,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/store/unitGaining',
    name: '设置单位',
    component: unitGaining,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/finance/invoiceDetail',
    name: '账单详情',
    component: invoiceDetail,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/service/Productconsultation',
    name: '商品咨询管理',
    component: Productconsultation,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/service/Reviews',
    name: '商品评价管理',
    component: Reviews,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: '/system/systemMessages',
    name: '系统消息',
    component: systemMessages,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },{
    path: '/version/versionAuto',
    name: '版本更新日志',
    component: versionAuto,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },{
    path: '/customer/customer',
    name: '客服系统',
    component: customer,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }]
}]
const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   // 这个语句用来解决报错
//   // 调用原来的push函数，并捕获异常
//   return routerPush.call(this, location).catch(error=> error)
// }
export default router



// WEBPACK FOOTER //
// ./src/router/index.js